import { render, staticRenderFns } from "./PysakkiList.vue?vue&type=template&id=1b31b77e&scoped=true"
import script from "./PysakkiList.vue?vue&type=script&lang=js"
export * from "./PysakkiList.vue?vue&type=script&lang=js"
import style0 from "./PysakkiList.vue?vue&type=style&index=0&id=1b31b77e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b31b77e",
  null
  
)

export default component.exports